import React from 'react';
import PropTypes from 'prop-types';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function Loading({ text }) {
  return (
    <div className="alert-popup text-center">
      <LoadingPlaceholder text={text} />
    </div>

  );
}

Loading.propTypes = {
  text: PropTypes.string,
};

Loading.defaultProps = {
  text: 'Loading ...',
};
